import { NudosTextArea, NudosUploadDownloadButton } from '../../../../NudosComponents';
import { validateImageOrPdfCallback, validateCsvCallback } from '../../../../../utils/validateFiles';
import {
  TProductConfigResponse,
  CONFIGURATION_CLASS_TYPE,
  CONFIG_STATUS_ID
} from '../../../../../types/product.configuration.types';
import { getFileUrlsFromEvidence, getCommentsFromEvidence } from '../../../../../utils/configurations';

import './CompletedConfigurationFields.scss';

const CompletedConfigurationFields = ({
  evidenceComments,
  setEvidenceComments,
  configurationData,
  uploadProofFile,
  uploadCsvFile
}: CompletedConfigurationFieldsProps) => {
  const { configClassName, status, evidence } = configurationData;

  const imageUrls = getFileUrlsFromEvidence(evidence);
  const comments = getCommentsFromEvidence(evidence);

  const configurationIsCreateAdmin = configClassName === CONFIGURATION_CLASS_TYPE.CREATE_ADMIN;
  const configurationIsHashId = configClassName === CONFIGURATION_CLASS_TYPE.HASH_ID;
  const customPdfOrJpgUploaderWidth = configurationIsCreateAdmin ? '280px' : '127px';
  const imageUrl = imageUrls?.[0] || undefined;
  const statusIsCompleted = status.statusId === CONFIG_STATUS_ID.COMPLETED;
  const currentFileUrl = statusIsCompleted ? imageUrl : undefined;
  const textValueForEvidenceComments =
    statusIsCompleted && configurationIsCreateAdmin ? comments || '' : evidenceComments || '';

  return (
    <div className="completedConfigurationFields">
      {configurationIsCreateAdmin && (
        <NudosTextArea
          label="Preguntas de seguridad"
          placeholder="Escribe las preguntas de seguridad y sus respuestas"
          currentValue={textValueForEvidenceComments}
          maxLength={500}
          setCurrentValue={setEvidenceComments}
          componentSize="medium"
          textHeight={64}
          noResize
          hidenCounter
        />
      )}

      <div className={`uploadersContainer ${configurationIsCreateAdmin ? 'hasTextArea' : 'noTextArea'}`}>
        <NudosUploadDownloadButton
          customClassName="uploadProofButton"
          customWidth={customPdfOrJpgUploaderWidth}
          uploadedFileHandler={uploadProofFile}
          downloadButtonText="Consultar evidencia"
          buttonEmptyText="PDF o JPG"
          buttonFilledText="PDF o JPG"
          showSkeletonLoader={false}
          keepOwnFileState
          currentFileUrl={currentFileUrl}
          validateFileCallback={validateImageOrPdfCallback}
        />
        {configurationIsHashId && (
          <NudosUploadDownloadButton
            customClassName="uploadCsvButton"
            customWidth="127px"
            uploadedFileHandler={uploadCsvFile}
            downloadButtonText="Consultar evidencia"
            buttonEmptyText="CSV"
            buttonFilledText="CSV"
            showSkeletonLoader={false}
            keepOwnFileState
            validateFileCallback={validateCsvCallback}
          />
        )}
      </div>
    </div>
  );
};

export default CompletedConfigurationFields;

export interface CompletedConfigurationFieldsProps {
  configurationData: TProductConfigResponse;
  uploadProofFile: (file?: File) => void;
  uploadCsvFile: (file?: File) => void;
  evidenceComments: string | undefined;
  setEvidenceComments: React.Dispatch<React.SetStateAction<string>>;
}
